<template>
  <div id="i18nIndex">
    <!-- 筛选 -->
    <div class="filter-container searchWarp" style="margin-bottom: -10px;">
      <el-select v-model="searchObj.project" clearable :placeholder="$t('i18nPage.Solution')" class="input-with-select" filterable @change="changeProject('searchObj',searchObj.project)">
        <el-option v-for="item in projectOption" :key="item" :label="item" :value="item" />
      </el-select>
      <el-select v-model="searchObj.module" filterable clearable allow-create default-first-option :placeholder="$t('i18nPage.module')" @change="changeSearch">
        <el-option v-for="item in moduleOption" :key="item" :label="item" :value="item" />
      </el-select>
      <el-input v-model="searchObj.key" clearable :placeholder="$t('i18nPage.Key')" class="input-with-select" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-model="searchObj.description" clearable class="input-with-select" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-button type="primary" icon="el-icon-download" style="vertical-align: top;margin: 10px;float: right;position: relative;z-index: 999;" @click="download" />
      <el-button type="primary" icon="el-icon-plus" style="vertical-align: top;margin: 10px;float: right;position: relative;z-index: 999;" @click="addOrEdit(null)" />
      <el-upload ref="upload" class="upload-demo" action="" :on-change="handleChange" :auto-upload="false">
        <el-button type="primary" icon="el-icon-upload2" style="vertical-align: top;margin: 10px;float: right;position: relative;z-index: 999;" />
      </el-upload>
    </div>
    <div>
      <el-table v-loading="listLoading" :data="tableList" element-loading-text="Loading" border fit highlight-current-row>
        <el-table-column :label="$t('i18nPage.Solution')" prop="project" align="center" min-width="10%" />
        <el-table-column :label="$t('i18nPage.module')" prop="module" align="center" min-width="10%" />
        <el-table-column :label="$t('i18nPage.Key')" prop="key" align="center" min-width="10%" />
        <!-- <el-table-column :label="$t('warningPage.Remark')" prop="description" align="center" min-width="15%" /> -->
        <el-table-column :label="$t('i18nPage.zh')" prop="valueZhCn" align="center" min-width="20%" />
        <el-table-column :label="$t('i18nPage.ft')" prop="valueZhHk" align="center" min-width="20%" />
        <el-table-column :label="$t('i18nPage.English')" prop="valueEn" align="center" min-width="20%" />
        <!-- <el-table-column :label="$t('i18nPage.Germany')" prop="valueDe" align="center" min-width="15%" />
        <el-table-column :label="$t('i18nPage.Japanese')" prop="valueJa" align="center" min-width="15%" />
        <el-table-column :label="$t('i18nPage.Korean')" prop="valueKo" align="center" min-width="15" /> -->
        <el-table-column align="center" :label="$t('yhubReport.Operating')" min-width="10%">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="addOrEdit(scope.row)" />
            <el-button type="primary" size="mini" icon="el-icon-delete" @click="deleteOne(scope.row.id)" />
          </template>
        </el-table-column>
      </el-table>

      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList"
            :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="popTitle" width="80%" :visible.sync="addAndEditDialog">
      <el-form id="batteryPop" ref="popObj" :rules="rules" :model="popObj" label-position="right" label-width="200px">
        <el-row :gutter="40">
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.Solution')" prop="project">
              <el-select v-model="popObj.project" filterable allow-create default-first-option @change="changeProject('popObj',popObj.project)">
                <el-option v-for="item in projectOption" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.module')" prop="module">
              <el-select v-model="popObj.module" filterable allow-create default-first-option>
                <el-option v-for="item in moduleOption" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.Key')" prop="key">
              <el-input v-model="popObj.key" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('warningPage.Remark')" prop="description">
              <el-input v-model="popObj.description" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.zh')" prop="valueZhCn">
              <el-input v-model="popObj.valueZhCn" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.ft')" prop="valueZhHk">
              <el-input v-model="popObj.valueZhHk" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.English')" prop="valueEn">
              <el-input v-model="popObj.valueEn" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.Germany')" prop="valueDe">
              <el-input v-model="popObj.valueDe" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.Japanese')" prop="valueDe">
              <el-input v-model="popObj.valueJa" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.Korean')" prop="valueDe">
              <el-input v-model="popObj.valueKo" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('i18nPage.French')" prop="valueFr">
              <el-input v-model="popObj.valueFr" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAndEditDialog = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitPop('popObj')">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryI18nValuePage, addI18nValue, editI18nValue, deleteI18nValue, upload, getModuleByProject, getProjectList } from '@/api/i18n'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'

export default {
  data() {
    return {
      searchObj: {
        project: '',
        module: '',
        key: '',
        description: ''
      },
      tableList: null,
      listLoading: true,
      isAdd: true,
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      addAndEditDialog: false,
      popTitle: i18n.t('adminView.add'),
      rules: {
        project: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        module: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        key: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      },
      popObj: {
        project: [],
        module: null
      },
      projectOption: [],
      moduleOption: []
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.rules.project[0].message = this.rules.module[0].message = this.rules.key[0].message = i18n.t('lease.Cannotbeblanked2')
    }
  },
  created() {
    this.queryList()
    this.initSelectOption()
  },
  methods: {
    queryList() {
      this.listLoading = true
      var param = {
        project: this.searchObj.project,
        module: this.searchObj.module,
        key: this.searchObj.key,
        value: this.searchObj.description,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      queryI18nValuePage(param).then(response => {
        this.tableList = response.resultModel.list
        this.listQuery.pageInfo.total = response.resultModel.total // 分页
        this.listLoading = false
      })
    },
    addOrEdit(row) {
      this.addAndEditDialog = true
      console.log(row)
      if (row) { // 编辑
        console.log(row)
        this.popObj = row
        this.isAdd = false
        this.popTitle = i18n.t('adminView.Edit')
      } else { // 新增
        this.popTitle = i18n.t('adminView.add')
        this.isAdd = true
        for (var attr in this.popObj) {
          if (attr != 'project' && attr != 'module') this.popObj[attr] = ''
        }
      }
    },
    deleteOne(id) {
      this.$confirm(i18n.t('i18nPage.deleteOne'), '', {// '确定删除该条数据吗？'
        // 是否关闭电子围栏
        confirmButtonText: i18n.t('button.Confirm'),
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteI18nValue({ id: id }).then(respone => {
          if (respone.resultCode === 1001) {
            this.$message({
              type: 'success',
              message: i18n.t('lease.Succeed')
            })
            this.addAndEditDialog = false
            this.queryList()
          }
        })
      }).catch(() => {})
    },
    submitPop(formName) { // 弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) { // 新增
            addI18nValue(this.popObj).then(respone => {
              if (respone.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: i18n.t('lease.Succeed')
                })
                this.addAndEditDialog = false
                this.queryList()
                this.initSelectOption()// 防止新增工程后，下拉框里没有
              }
            })
          } else {
            editI18nValue(this.popObj).then(respone => {
              if (respone.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: i18n.t('lease.Succeed')
                })
                this.addAndEditDialog = false
                this.queryList()
                this.initSelectOption()// 防止新增工程后，下拉框里没有
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    initSelectOption() { // 查询工程列表
      getProjectList().then(res => {
        if (res.resultCode == 1001) {
          this.projectOption = res.resultModel || []
        }
      })
    },
    changeProject(val, projectVal) {
      this.moduleOption = []
      switch (val) {
        case 'searchObj':this.searchObj.module = ''; break
        case 'popObj':this.popObj.module = ''; break
      }
      getModuleByProject({ project: projectVal }).then(res => {
        if (res.resultCode == 1001) {
          this.moduleOption = res.resultModel || []
        }
      })
      this.changeSearch()
    },
    // 筛选改变事件
    changeSearch() {
      this.replaceFn(this.searchObj.project)
      this.replaceFn(this.searchObj.module)
      this.replaceFn(this.searchObj.key)
      this.replaceFn(this.searchObj.description)
      this.listQuery.pageInfo.pageNum = 1
      this.listQuery.pageInfo.pageSize = 10
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    replaceFn(val) {
      if (val) { // 去掉首尾空格
        val = val.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
    },
    handleChange(file, fileList) { // //上传版本--弹窗--上传文件
      console.log(file)
      var file_name = file.name
      this.$refs.upload.clearFiles()
      var isyes = false
      var file_nameArr = file_name.split('.')
      if (file_nameArr[file_nameArr.length - 1] == 'xlsx' || file_nameArr[file_nameArr.length - 1] == 'xls')isyes = true // 校验后缀，需注意如：123.png.xls
      if (!isyes) { // 后缀错误
        this.$notify({
          title: i18n.t('adminView.IncorrectFile'), // '文件名后缀错误！',
          message: '请上传Excel文档', // '文件名后缀必须为 "bin" ',
          type: 'error',
          duration: 4000
        })
        return
      }
      upload(file).then(response => {
        this.$notify({
          title: '',
          message: i18n.t('lease.Succeed'),
          type: 'success',
          duration: 2000
        })
        this.queryList()
      })
    },
    download() {
      var param = {
        project: this.searchObj.project,
        module: this.searchObj.module,
        key: this.searchObj.key,
        value: this.searchObj.description,
        pageNum: 1, // 分页--选中某一页
        pageSize: 3000 // 分页--每一页的列表的行数 10 20 50
      }
      // console.log(param)
      var url = process.env.VUE_APP_BASE_API + '/v3/manager/i18n/exportResult'
      url += '?project=' + param.project + '&module=' + param.module + '&key=' + param.key + '&value=' + param.value + '&pageNum=' + param.pageNum + '&pageSize=' + param.pageSize
      window.open(url, '_bank')
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>
<style lang="scss">
#i18nIndex{
  background:#fff;
  padding:0 20px 20px;
  .searchWarp .el-input-group {
    width: 20%!important;
    max-width: 400px!important;
    margin-top: 13px;
  }
  .searchWarp .el-table .cell {
    line-height: 24px!important;
  }
  .el-table .cell{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  #batteryPop{
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-select{
      width:100%;
    }
  }
  .upload-demo{
    float:right;
  }
}
</style>
